import { graphql } from 'react-apollo';

import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { isAuthenticatedUser } from 'js/lib/user';

import type { GetPartnersByUserRequest } from '@coursera/grpc-types-educatoradmin/coursera/proto/educatoradmin/adminproductdirectory/v1beta1/user_partners_api';

import type { Partner } from 'bundles/admin-v2/constants/types';
import type { PartnerAdmin } from 'bundles/admin-v2/utils/partner';
import { makePartnerIdNumeric } from 'bundles/admin-v2/utils/partner';

/* eslint-disable graphql/template-strings */
const getPartnersByUserQuery = gql`
  query GetPartnersByUserQuery {
    GetPartnersByUser(input: {})
      @rest(
        type: "GetPartnersByUserResponse"
        path: "grpc/educatoradmin/adminproductdirectory/v1beta1/UserPartnersAPI/GetPartnersByUser"
        method: "POST"
      ) {
      partner
    }
  }
`;
/* eslint-enable graphql/template-strings */

type GraphQLResponse = {
  GetPartnersByUser: {
    partner: Array<PartnerAdmin>;
  };
};

export const withPartnersByUser = graphql<
  {},
  GraphQLResponse,
  GetPartnersByUserRequest,
  {
    partnersByUser: Array<Partner> | undefined;
  }
>(getPartnersByUserQuery, {
  skip: () => !isAuthenticatedUser(),
  props: ({ data, ownProps }) => {
    const partnersByUser = data?.GetPartnersByUser?.partner;
    const partnersCastedPartnerIdToNumber = partnersByUser?.map(makePartnerIdNumeric);

    return {
      ...ownProps,
      partnersByUser: partnersCastedPartnerIdToNumber,
    };
  },
});

/**
 * Fetch the partners that a user has access to
 *
 * Calls the GRPC UserPartnersAPI/GetPartnersByUser via Apollo.
 */
export const usePartnersByUser = () => useQuery<GraphQLResponse, GetPartnersByUserRequest>(getPartnersByUserQuery);
